import { useCallback, useMemo } from 'react';
import { resolveSpecialtyAttributes, toSearchQuery } from '../../utils/specialtyAttributes';
import { TipPart, UseVideoClassificationTipReturn, VideoClassificationTipProps } from './types';

/**
 * VideoClassificationTipコンポーネントのロジックを管理するカスタムフック
 *
 * 診療科と、その動画に付いているキー付きタグ（部位:膝 など）を検索可能なタグとして並べる。
 * 診療科ごとの分岐は持たず、どの科でも同じ形で表示する。
 */
export const useVideoClassificationTip = ({ video }: VideoClassificationTipProps): UseVideoClassificationTipReturn => {
  // 表示するタグを生成する
  const tipParts = useMemo<TipPart[]>(() => {
    if (!video || !video.specialty?.name) return [];

    const specialtyName = video.specialty.name;
    const parts: TipPart[] = [
      {
        text: specialtyName,
        searchQuery: `診療科:${specialtyName}`
      }
    ];

    resolveSpecialtyAttributes(video).forEach(attribute => {
      parts.push({
        text: attribute.attribute_value,
        searchQuery: toSearchQuery(attribute)
      });
    });

    return parts;
  }, [video]);

  // タグクリック時の処理
  const handleTagClick = useCallback((searchQuery: string) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('q', searchQuery);
    window.location.href = `/?${searchParams.toString()}`;
  }, []);

  return {
    tipParts,
    handleTagClick
  };
};
